module.exports = __webpack_public_path__ + "static/img/czsc2.fc7aef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/czsc2.png
// module id = 1444
// module chunks = 3